export const initialState = {
  detailinfo: [],
  detail_info: {},
};

export const productDetailInformationReducer = (state, action) => {
  switch (action.type) {
    case 'detail_info':
      return {
        ...state,
        detail_info: action.value,
      };
    case 'ADD_DETAIL_INFORMATION':
      return {
        ...state,
        detailinfo: state.detailinfo.concat([action.value]),
      };
    case 'DELETE_DETAIL_INFORMATION':
      return {
        ...state,
        detailinfo: state.detailinfo.filter(
          (option) => option.id !== action.value
        ),
      };
    case 'CHANGE_DETAIL_INFORMATION':
      return {
        ...state,
        detailinfo: state.detailinfo.map((item) => {
          if (item.id === action.value.id) {
            return { ...action.value };
          }

          return { ...item };
        }),
      };
    default:
      throw new Error(`${action.type}을 찾을 수 없습니다.`);
  }
};
